<template>
  <StrengthsMapping
    v-if="strengthsMappingModel && !finishedMappingBeforeThisVisit"
    :model="strengthsMappingModel"
    :embedded="true"
    :number-of-pages="numberOfPages"
    @submit-review="onSubmitReview"
  />
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, watch } from "vue";
import Debug from "debug";
import StrengthsMapping from "../../views/strengths-mapping/strengths-mapping.vue";
import { StrengthsMappingModel } from "../../api-models";
import { useAxios } from "../../composables/api";
import SessionInstanceState from "./session-instance-state";
import { useCmsSessionStore } from "../../stores/useCmsSessionStore";
import pinia from "../../stores";
import { QuestionnaireType } from "../../services/cms/cms-type-definitions";

const debug = Debug("cs.StrengthsMappingSlide");

const props = defineProps<{ questionnaireType: QuestionnaireType; canReMapStrengths: boolean }>();
const { data: strengthsMappingModel } = useAxios<StrengthsMappingModel | string>(
  props.questionnaireType === "indicators"
    ? `/api/strengthsmapping/indicators?allowRemapping=${props.canReMapStrengths}`
    : `/api/foundation?allowRemapping=${props.canReMapStrengths}`,
);

const numberOfPages = computed(() => (props.questionnaireType === "indicators" ? 3 : 4));

const cmsSessionStore = useCmsSessionStore(pinia());

const finishedMappingBeforeThisVisit = computed<boolean>(
  () => strengthsMappingModel.value === "User has completed solo",
);

const onSubmitReview = (): void => {
  cmsSessionStore.updateMappingStatus(props.questionnaireType, true);
};

watch([finishedMappingBeforeThisVisit], () => {
  // cmsSessionStore.updateMappingStatus(finishedMappingBeforeThisVisit.value);
  cmsSessionStore.updateMappingStatus(
    props.questionnaireType,
    finishedMappingBeforeThisVisit.value,
  );
});

onMounted(() => {
  debug("mounted");
  if (cmsSessionStore.hasFinishedMapping[props.questionnaireType]) {
    // Reload after resize, user has already completed the mapping during this session
    cmsSessionStore.updateMappingStatus(props.questionnaireType, true);
  } else if (!strengthsMappingModel.value) {
    debug("NO VALUE");
    // The user completed mapping earlier and is revisiting the session
  }

  const isFinished =
    cmsSessionStore.hasFinishedMapping[props.questionnaireType] ||
    finishedMappingBeforeThisVisit.value;
  cmsSessionStore.updateMappingStatus(props.questionnaireType, isFinished);

  // cmsSessionStore.updateMappingStatus(isFinished);
});

onUnmounted(() => {
  debug("destroyed");
  SessionInstanceState.set(
    "hasFinishedMapping",
    cmsSessionStore.hasFinishedMapping[props.questionnaireType],
  );
  SessionInstanceState.set("finishedMappingBeforeThisVisit", finishedMappingBeforeThisVisit.value);
});
</script>
